// store/slices/organizationSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchOrganizationByIdThunk, updateOrganizationThunk } from './organizationThunks';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganization(state, action) {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH BY ID
      .addCase(fetchOrganizationByIdThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganizationByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOrganizationByIdThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updateOrganizationThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOrganizationThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateOrganizationThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setOrganization } = organizationSlice.actions;
export default organizationSlice.reducer;
